
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Button from "../../components/utils/Button";
import { Link } from "react-router-dom";
import CardLayout from "../../components/utils/CardLayout";
// import { useDispatch, useSelector } from "react-redux";

const DetailRow = ({ label, value }) => {
  return (
    <div className="d-flex justify-content-between gap-3 py-2 ">
      <span className="text-muted fw-semibold">
        {label}
      </span>

      <span className="text-end">
        {value || "-"}
      </span>
    </div>
  );
};

const CheckStatus = () => {
  const [showDetails, setShowDetails] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      searchvalues: "",
    },
  });

  const onSubmit = async (data) => {
    console.log(data);
    setShowDetails(true);

  };
  const handleReset = () => {
    reset();
    setShowDetails(false);
  };

  return (
    <CardLayout
      title={<> Check Status</>}
      icon="fas fa-tasks menu-icon  " >
         <div className="row">
        {/* center Side */}
        <div className="col-lg-12">
          <form
            onSubmit={handleSubmit(onSubmit)} noValidate >
            <div className="row">
              {/*  Serial Number / MSISDN  */}
              <div className="col-lg-3 mb-2">
                <label className="form-label fw-semibold">
                  Serial Number / MSISDN <span className="text-danger">*</span>
                </label>

                <input
                  type="text"
                  className={`form-control ${errors.searchvalues ? "is-invalid" : ""
                    }`}
                  placeholder="Serial Number / MSISDN"
                  {...register("searchvalues", {
                    required: "Serial Number or MSISDN is required",
                    validate: (value) => {
                      const val = value.trim();

                      if (!/^\d+$/.test(val)) {
                        return "Only numbers are allowed"
                      }
                      return true;
                    }
                  })}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/\D/g, ""); // allow only numbers
                  }}
                />

                <div className="invalid-feedback"> {errors.searchvalues?.message} </div>
              </div>


              {/* Submit */}
              <div className="col-md-3 d-flex align-items-end" style={{ height: '70px' }}>
                <div className="d-flex gap-3">
                  <Button
                    title="Get Details"
                    buttonType="submit"
                    variant="primary"
                    icon={<i className="ri-search-line me-2"></i>} />
                  <Button
                    title="Reset"
                    buttonType="button"
                    variant="secondary"
                    icon={<i className="ri-refresh-line me-2"></i>}
                    onClick={handleReset} />
                </div>
              </div>
            </div>
          </form>
          {showDetails &&
            <div className="row g-3">

              {/* Subscriber Details */}
              <div className="col-lg-4">
                <div className="card h-100 border">
                  <div className="card-header fw-semibold">
                    Subscriber Details
                  </div>

                  <div className="card-body py-1">

                    <DetailRow
                      label="Carrier Status"
                      value="Success" />

                    <DetailRow
                      label="Carrier Subscriber Status"
                      value="Not-Active" />

                    <DetailRow
                      label="Nexus Subscriber Status"
                      value="Not-Active" />

                    <DetailRow
                      label="Activation Date"
                      value="1/20/2026 8:43:06 AM" />

                  </div>
                </div>
              </div>

              {/* Plan Information */}
              <div className="col-lg-4">
                <div className="card h-100 border">
                  <div className="card-header fw-semibold">
                    Plan Information
                  </div>

                  <div className="card-body py-1">

                    <DetailRow
                      label="MSISDN"
                      value="-" />

                    <DetailRow
                      label="ICCID"
                      value="-" />

                    <DetailRow
                      label="Market ZIP"
                      value="-" />

                    <DetailRow
                      label="Status Changed Date"
                      value="-" />

                  </div>
                </div>
              </div>

              {/* Plan Information */}
              <div className="col-lg-4">
                <div className="card h-100 border">
                  <div className="card-header fw-semibold">
                    Plan Information
                  </div>

                  <div className="card-body py-1" >

                    <DetailRow
                      label="Plan ID"
                      value="-"
                    />

                    <DetailRow
                      label="Plan Name"
                      value="-"
                    />

                    <DetailRow
                      label="Billing Code"
                      value="-"
                    />

                    <DetailRow
                      label="Expiration Date"
                      value="-"
                    />

                  </div>
                </div>
              </div>

              {/* E911 Address */}
              <div className="col-lg-12">
                <div className="card border">
                  <div className="card-header fw-semibold">
                    E911 Address
                  </div>

                  <div className="card-body py-1">
                    <div className="row">

                      <div className="col-lg-3">
                        <DetailRow
                          label="Street"
                          value="-"
                        />
                      </div>

                      <div className="col-lg-3">
                        <DetailRow
                          label="City"
                          value="-"
                        />
                      </div>

                      <div className="col-lg-3">
                        <DetailRow
                          label="State"
                          value="-"
                        />
                      </div>

                      <div className="col-lg-3">
                        <DetailRow
                          label="Zipcode"
                          value="-"
                        />
                      </div>

                    </div>
                  </div>
                </div>
              </div>

            </div>
          }

        </div>
      </div>
    </CardLayout>
  );
 

};

export default CheckStatus;
